import * as yup from 'yup'

export const VehicleValueValidation = yup.number()
